import { useState } from 'react'

import { useConfigureModalController, useModalController, useCloseModal } from '@/atoms'

type ModalState = 'ready' | 'submitting'
type ModalData = {
  userId: string
}

export const modalId = 'disableUserConfirmationModal'

export const useController = () => useModalController<ModalData, ModalState>(modalId)

export const useConfigureController = (userId: string) => {
  const close = useCloseModal()

  // INITIALIZATION

  const [options] = useState(() => ({
    createInitialState: () => ({
      close,
      data: {
        userId,
      },
    }),
  }))

  return useConfigureModalController<ModalData, ModalState>(modalId, options)
}
